import { connect }    from 'react-redux';
import SelectAccount  from 'components/SelectAccount';

const mapStateToProps = state => ({
  authenticationScopes: state.authenticationScopes
});

const SelectAccountContainer = connect(mapStateToProps)(SelectAccount);
export default SelectAccountContainer;
